import { render, staticRenderFns } from "./SetupStep4.vue?vue&type=template&id=c0326fbc&"
import script from "./SetupStep4.vue?vue&type=script&lang=ts&"
export * from "./SetupStep4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports